/**
 * 外观与通知设置页懒加载壳（14.31c；MyPrivacyLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function MyAppearanceLazy() {
  const { mod } = useLazyModule(() => import('./MyAppearancePage'));
  if (mod === null) return <div data-testid="my-appearance-loading-shell">加载中…</div>;
  return <mod.MyAppearancePage />;
}
